import { element } from 'protractor';
import { DISABLED } from '@angular/forms/src/model';
import { Component, OnInit } from '@angular/core';
import { RegistrationService } from '../../registration.service';


import { FormGroup, FormControl, NgForm, Validators } from '@angular/forms';
import { forEach } from '@angular/router/src/utils/collection';
import swal from 'sweetalert2';

import { HandleError } from '../../shared/HandleError';

@Component({
  selector: 'app-battlecasualty',
  templateUrl: './battlecasualty.component.html',
  styleUrls: ['./battlecasualty.component.css']
})
export class BattlecasualtyComponent implements OnInit {
  [x: string]: any;
  SBC_PDFFile: any;
  fileToUpload: File = null;
  formInvalid: boolean = false;
  SainikDetails: any;
  CasualtyTypes: any;
  title = "Battle Casualty";
  data: any;
  s: any = {};
  sr: any = {};
  mode: string = "save";
  isSainikExist: boolean = false;
  Formdiable: boolean = false;
  finalizeddata: any;

  constructor(private service: RegistrationService,private handleError:HandleError) {
  }

  ngOnInit() {
    this.GetAllCasualtyType();
    this.UserName=localStorage.getItem('userName');
    this.RoleName=localStorage.getItem('userRole');
    if(this.RoleName=='sainik'|| this.RoleName=='Sainik'){
    //this.s.SR_ServiceNo=this.UserName;
    this.sr.SR_ServiceNo=this.UserName;
    // this.GetSainikBasicDetails(this.s.SR_ServiceNo)
    this.GetSainikDetailsFromRegistration(this.UserName);
   
    this.GetfinalizedDataForBattle(this.UserName);
    }
  }

  GetfinalizedDataForBattle(SR_ServiceNo)
  {
    debugger;
    this.data = this.service.getfinalizedDataForBattle(SR_ServiceNo);
    this.data.subscribe(
      (response) => {
        this.finalizeddata=response;
        if(this.finalizeddata=='F')
       {
        this.Formdiable=true;
       }
      },
      (error) => {
        console.log(error);
      });
  }
  GetSainikDetailsFromRegistration(SR_ServiceNo: any) {
    this.isSainikExist = false;
    document.getElementById('loader-spinner').style.display = "block";
    this.s="";
    this.SBC_PDFFile="";
    this.data = this.service.getSainikBasicDetailsForBattle(SR_ServiceNo);
    this.data.subscribe(
      (response) => {
        this.sr = response.sainikRegistrationBasicDetails;
        this.isSainikExist = true;
        if(response.SainikBattleCasualty!=null)
        {
        this.mode = "update";
        this.s = response.SainikBattleCasualty;
        if (this.s.SBC_Date != null)
          this.s.SBC_Date = ((this.s.SBC_Date).split('T'))[0];
        this.s.SBC_CasualtyType=this.s.CasualtyTypes.Casualty_Id;  
        this.SBC_PDFFile=response.SainikBattleCasualty.SBC_BriefHistoryFile;
        }
        //  this.s.SR_ServiceType=response.sainikRegistrationBasicDetails.ServiceTypes.SR_ServiceType;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 400)
        //swal('Warning!', 'Sainik does not exist.', 'warning');
        swal('Warning!', 'Sainik does not belong to this district.', 'warning');
        // else if(error.status == 401)
        //   swal('Warning!', 'Not authorized to access this page.', 'warning');
        this.handleError.ErrorHandler(error);
      });
  }

  onCasualityTypeChanged(form,event)
  {    
    var element = <HTMLInputElement> document.getElementById("SBC_Disability_Percentage");
    if (event.value ==1)
    {
      form.controls["SBC_Disability_Percentage"].setValidators([Validators.required]);
      form.controls["SBC_Disability_Percentage"].updateValueAndValidity();
      element.disabled = false;
    }
    else
    {      
      form.controls["SBC_Disability_Percentage"].clearValidators();
      form.controls["SBC_Disability_Percentage"].updateValueAndValidity();
      element.value="";
      element.disabled=true;
      
    }
  }
  GetAllCasualtyType() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getAllCasualtyType();
    this.data.subscribe(
      (response) => {
        this.CasualtyTypes = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetSainikBasicDetails(SR_ServiceNo: any) {
    debugger;
    this.isSainikExist = false;
    document.getElementById('loader-spinner').style.display = "block";
    this.s="";
    this.SBC_PDFFile="";
    this.data = this.service.getSainikBasicDetailsForBattle(SR_ServiceNo);
    this.data.subscribe(
      (response) => {
        this.sr = response.sainikRegistrationBasicDetails;
        this.isSainikExist = true;
        if(response.SainikBattleCasualty!=null)
        {
        this.mode = "update";
        this.s = response.SainikBattleCasualty;
        if (this.s.SBC_Date != null)
          this.s.SBC_Date = ((this.s.SBC_Date).split('T'))[0];
        this.s.SBC_CasualtyType=this.s.CasualtyTypes.Casualty_Id; 
        this.SBC_PDFFile=response.SainikBattleCasualty.SBC_BriefHistoryFile;
        this.Fileupload=response.SainikBattleCasualty.Fileupload;
        }
        //  this.s.SR_ServiceType=response.sainikRegistrationBasicDetails.ServiceTypes.SR_ServiceType;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 400)
        if(this.RoleName=="Super Admin"){
          swal('Warning!', 'Sainik does not exist, Please fill the details', 'warning');
        }
        else{
        swal('Warning!', 'Sainik does not belong to this district or Sainik does not exist', 'warning');
         }
        //swal('Warning!', 'Sainik does not exist.', 'warning');
        //swal('Warning!', 'Sainik does not belong to this district.', 'warning');
        // else if(error.status == 401)
        //   swal('Warning!', 'Not authorized to access this page.', 'warning');
        this.handleError.ErrorHandler(error);
      });
  }
  FileInput(file: FileList) {
    debugger;
   //let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
   let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|JPEG|JPG)$/;
   let s: any = file.item(0).size / 1024;
   let size: any = parseFloat(s).toFixed(2);
   let uploadedFilename = file.item(0).name;
   if (uploadedFilename.match(regex) && (size <= 5048)) {
     this.fileToUpload = file.item(0);
     var reader = new FileReader();
     reader.onload = (event: any) => {
       // this.FeasibilityPDFUrl = event.target.result;
     }
     reader.readAsDataURL(this.fileToUpload);
     const data = new FormData();
     data.append("UploadedImage", file.item(0));
     let x = this.service.uploadImage(data);
     x.subscribe(
       (response) => {
         // console.log(response);
         // this.app.APP_PA_PhotoErrorMessage="";
 
       }, (error) => {
         let i: any = document.getElementById('SBC_BriefHistoryFile');
         i.value = "";
         if (error.status == 400) {
           // this.FeasibilityPDFUrl = "assets/images/image-default.png";
           swal('Warning!', error.error.Message, 'warning');
         }
       });
   }
   else {
     let i: any = document.getElementById('SBC_BriefHistoryFile');
     i.value = "";
     if (!uploadedFilename.match(regex))
       swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
     else if (size > 2048)
       swal('Warning!', "Please upload image file less than 2mb", 'warning');
   }
 }
 
 
 getImagePDFUrl() {
   let imagename = null;
   try {
     imagename = document.getElementById('SBC_BriefHistoryFile');
     return imagename.files[0].name;
   }
   catch (e) {
     return null;
   }
 }

  //wr

//   BriefHistoryFileInput(file: FileList) {
//     console.log(file);
//     this.fileToUpload = file.item(0);
//     var reader = new FileReader();
//     reader.readAsDataURL(this.fileToUpload);
//     const data = new FormData();
//     data.append("UploadedImage", file.item(0));
//     let x = this.service.uploadImage(data);
//     x.subscribe(
//       (response) => {
//         console.log(response);
//       }, (error) => {
//         console.log(error);
//       });
//   }

//   getBriefHistoryFile() {
//     let pdfname = null;
//     try {
//       pdfname = document.getElementById('SBC_BriefHistoryFile');
//       return pdfname.files[0].name;
//     }
//     catch (e) {
//       return null;
//     }
//   }

//  pdffile:any="";
//  pdflink:any="";


//   splitgetBriefHistoryFile()
//   {
//     let BriefHistoryFile = (this.s.SBC_BriefHistoryFile).split('/');
//     this.pdflink = BriefHistoryFile[7];
//     let pdf= (this.pdflink).split('?');
//     this.pdffile = pdf[0];
//   }

  ClearForm(){
    this.sr.SR_ServiceType="";
    this.sr.SR_Category="";
    this.sr.SR_Name="";
    this.sr.SR_SurName="";
}

  SaveBattleCasualty(serviceNo,sainikId, bc: NgForm) {
    debugger;
    // if (this.s.SBC_Date == "" || this.s.SBC_Date == null || this.s.SBC_Date == undefined)
    //     swal("Warning!", "Please enter the date", "warning");    
    //  if (this.s.SBC_CasualtyType == null || this.s.SBC_CasualtyType == "" ||this.s.SBC_CasualtyType == undefined)
    //     swal("Warning!", "Please enter casualty type", "warning");
   // if (this.checkAllValidation(bc)) {
    if (bc.valid) {
      document.getElementById('loader-spinner').style.display = "block";

      bc.value.SBC_BriefHistoryFile = this.getImagePDFUrl();

      this.data = this.service.saveBattleCasualty(serviceNo,sainikId, bc.value);
      this.data.subscribe(
        (response) => {
          console.log(bc)
          if(this.RoleName=='sainik'|| this.RoleName=='Sainik'){
            this.GetSainikDetailsFromRegistration(this.UserName);
          }
          else{
          bc.reset();
          bc.resetForm();
          //f.form.markAsPristine();
          // f.form.markAsUntouched();
          this.sr.SR_ServiceType="";
          this.sr.SR_Category="";
          this.sr.SR_Name="";
          this.sr.SR_SurName="";
          }
          //this.s.SBC_BriefHistory="";
          this.formInvalid = false;
          swal('Success!', 'Sainik Battle Casualty details has been saved successfully.', 'success');
           document.getElementById('loader-spinner').style.display = "none";
          // window.location.href='http://sainik.esdinfra.com/index.html#/';
        }, (error) => {
          console.log(error);
          document.getElementById('loader-spinner').style.display = "none";
          this.handleError.ErrorHandler(error);
        });
    }
 // }
    else {
      //  swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
       swal('Warning!', 'Please fill the mandatory(*) fields.', 'warning');
      this.formInvalid = true;
    }
  }


  UpdateBattleCasualty(serviceNo,sainikId, bc: NgForm) {
    debugger;
    //if (this.checkAllValidation(bc)) {
     //if (bc.valid) {
      this.formInvalid = false;
      document.getElementById('loader-spinner').style.display = "block";
      // if(bc.value.SBC_BriefHistoryFile!=null)
      // bc.value.SBC_BriefHistoryFile = this.splitgetBriefHistoryFile();
      //else
     // bc.value.SBC_BriefHistoryFile = this.splitgetBriefHistoryFile();
      bc.value.SBC_BriefHistoryFile = this.getImagePDFUrl();
      bc.value.Fileupload=this.Fileupload;
     // bc.value.SBC_BriefHistoryFile=this.pdffile;
      this.data = this.service.updateBattleCasualty(serviceNo,sainikId, bc.value);
      this.data.subscribe(
        (response) => {
          console.log(bc);
          if(this.RoleName=='sainik'|| this.RoleName=='Sainik'){
            this.GetSainikDetailsFromRegistration(this.UserName);
          }
          else{
          bc.reset();
          bc.resetForm();
          this.sr.SR_ServiceType="";
          this.sr.SR_Category="";
          this.sr.SR_Name="";
          this.sr.SR_SurName="";
          }
          // this.s.SBC_BriefHistoryFile="";
          this.formInvalid = false;
          swal('Success!', 'Sainik battles has been updated successfully.', 'success');
          document.getElementById('loader-spinner').style.display = "none";
          document.getElementById('ServiceNo').focus();
        }, (error) => {
          console.log(error);
          document.getElementById('loader-spinner').style.display = "none";
          this.handleError.ErrorHandler(error);
        });
   }
  // else {
  //    swal('Warning!', 'There are errors, please select atleast one award.', 'warning');
  //   this.formInvalid = true;
  //  }
 // }



 //
// *********validation********** */
//checkAllValidation(bc: any) {
  //let result1 = this.CheckBattleCasualtyDate(bc.value.SBC_Date);
  // let result2 = this.CheckFamilyDOB(fd.SD_DOB);
  // let result3 = this.CheckFamilyRelation(fd.SD_Relation);
  // let result4 = this.CheckFamilyQualification(fd.SD_Qualifictaion);

  //if (result1 && result2 && result3 && result4)
 // if (result1)
  //  return true;
  //else
  //  return false;
//}

// CheckBattleCasualtyDate(date) {
//   debugger;
//   if (this.CheckRequired(date)) {
//     this.BC_Date_errormessage = "";
//     return true;
//   }
//   else {
//     this.BC_Date_errormessage = "Please select Date";
//     return false;
//   }
// }

// CheckFamilyDOB(dob) {
//   if (this.CheckRequired(dob)) {
//     this.SD_DOB_errormessage = "";
//     return true;
//   }
//   else {
//     this.SD_DOB_errormessage = "Please enter DOB";
//     return false;
//   }
// }

// CheckFamilyRelation(relation) {
//   if (this.CheckRequired(relation)) {
//     this.SD_Relation_errormessage = "";
//     return true;
//   }
//   else {
//     this.SD_Relation_errormessage = "Please enter relation";
//     return false;
//   }
// }

// CheckFamilyQualification(qualification) {
//   if (this.CheckRequired(qualification)) {
//     this.SD_Qualifictaion_errormessage = "";
//     return true;
//   }
//   else {
//     this.SD_Qualifictaion_errormessage = "Please select qualification";
//     return false;
//   }
// }

}



// WEBPACK FOOTER //
// ./src/app/sainik-registration/battlecasualty/battlecasualty.component.ts